<template>
  <div :class="$style.switchLang">
    <button
      v-for="lang in languages"
      :key="lang"
      :class="[$style.btnLang, { [$style.btnActive]: isActive(lang) }]"
      @click="switchLang(lang)"
    >
      {{ lang }}
    </button>
  </div>
</template>

<script>
  import { CURRENT_LOCALES } from '@/api/i18n/const/localeType';

  export default {
    computed: {
      languages() {
        return CURRENT_LOCALES;
      },
    },
    methods: {
      isActive(lang) {
        return this.$i18n.locale === lang;
      },
      switchLang(lang) {
        if (this.$i18n.locale === lang) return;

        this.$i18n.locale = lang;
        localStorage.setItem('locale', lang);
        this.$router.go();
      },
    },
  };
</script>

<style lang="scss" module>
  .switchLang {
    color: grey;
    gap: 10px;
    align-items: center;
  }

  .btnLang {
    cursor: pointer;
    padding: 0;
    border: none;
    font: inherit;
    color: grey;
    background-color: transparent;
    &:hover {
      opacity: 0.7;
      transition: opacity 200ms linear;
    }
  }

  .btnActive {
    border-bottom: 1px solid gray;
  }
</style>
